module.exports = __webpack_public_path__ + "img/megafon.b628b84e.png";